
goog.provide('el8.appchart.refpanel.RefPanelSection');

goog.require('el8.model.base');
goog.require('el8.uiwidget.Component');

/**
 * This is the base class for sections in the LHS, aka Clinical Profile, 
 * aka Reference Panel. Put common functionality here. Sections are all
 * expected to have their container as an attribute.
 */
el8.appchart.refpanel.RefPanelSection = function(spec) {
    spec = spec || {};
    el8.uiwidget.Component.apply(this, arguments);
    this.containers = [];
};
el8.appchart.refpanel.RefPanelSection.inheritsFrom(el8.uiwidget.Component);


el8.appchart.refpanel.RefPanelSection.prototype.addContainer = function(container) {
	this.containers.push(container);
};

el8.appchart.refpanel.RefPanelSection.prototype.collapse = function() {
	_.each(this.containers, function(container) {container.trigger('el8_collapse');});
};

el8.appchart.refpanel.RefPanelSection.prototype.expand = function() {
	_.each(this.containers, function(container) {container.trigger('el8_expand');});
};

el8.appchart.refpanel.RefPanelSection.prototype.isCollapsed = function() {
    return _.every(this.containers, function(container) {
        return Boolean(container.attr('_collapsed'));
    });

};
